// Indian ring sizes (1–30) with inner diameter / circumference and US / UK equivalents.
export const RING_SIZES = [
  { in: 1, dia: 13.1, circ: 41.0, us: "1½", uk: "C" },
  { in: 2, dia: 13.4, circ: 42.0, us: "2", uk: "D" },
  { in: 3, dia: 13.7, circ: 42.9, us: "2¼", uk: "E" },
  { in: 4, dia: 14.0, circ: 43.9, us: "2½", uk: "E½" },
  { in: 5, dia: 14.3, circ: 44.8, us: "3", uk: "F" },
  { in: 6, dia: 14.7, circ: 46.1, us: "3½", uk: "G" },
  { in: 7, dia: 15.1, circ: 47.4, us: "4", uk: "H½" },
  { in: 8, dia: 15.3, circ: 48.0, us: "4½", uk: "I½" },
  { in: 9, dia: 15.5, circ: 48.7, us: "5", uk: "J½" },
  { in: 10, dia: 15.9, circ: 50.0, us: "5½", uk: "K½" },
  { in: 11, dia: 16.3, circ: 51.2, us: "5¾", uk: "L½" },
  { in: 12, dia: 16.5, circ: 51.9, us: "6", uk: "M" },
  { in: 13, dia: 16.9, circ: 53.1, us: "6½", uk: "N" },
  { in: 14, dia: 17.3, circ: 54.4, us: "7", uk: "O" },
  { in: 15, dia: 17.5, circ: 55.1, us: "7¼", uk: "P" },
  { in: 16, dia: 17.9, circ: 56.3, us: "7½", uk: "P½" },
  { in: 17, dia: 18.1, circ: 57.0, us: "8", uk: "Q" },
  { in: 18, dia: 18.5, circ: 58.3, us: "8½", uk: "Q½" },
  { in: 19, dia: 18.8, circ: 58.9, us: "9", uk: "R½" },
  { in: 20, dia: 19.2, circ: 60.2, us: "9¼", uk: "S" },
  { in: 21, dia: 19.4, circ: 60.8, us: "9½", uk: "S½" },
  { in: 22, dia: 19.8, circ: 62.1, us: "10", uk: "T½" },
  { in: 23, dia: 20.0, circ: 62.7, us: "10¼", uk: "U" },
  { in: 24, dia: 20.4, circ: 64.0, us: "10½", uk: "U½" },
  { in: 25, dia: 20.6, circ: 64.6, us: "11", uk: "V½" },
  { in: 26, dia: 21.0, circ: 65.9, us: "11½", uk: "W½" },
  { in: 27, dia: 21.4, circ: 67.2, us: "12", uk: "Y" },
  { in: 28, dia: 21.6, circ: 67.8, us: "12¼", uk: "Y½" },
  { in: 29, dia: 21.9, circ: 68.8, us: "12½", uk: "Z" },
  { in: 30, dia: 22.3, circ: 70.0, us: "13", uk: "Z+1" },
];

// Indian bangle sizes: "2.4" reads as 2 and 4/16 inches inner diameter.
export const BANGLE_SIZES = [
  { size: "2.2", diaIn: "2⅛″", diaMm: 54.0, circMm: 169.6, fit: "Petite / slim hands" },
  { size: "2.4", diaIn: "2¼″", diaMm: 57.2, circMm: 179.6, fit: "Small — most common" },
  { size: "2.6", diaIn: "2⅜″", diaMm: 60.3, circMm: 189.5, fit: "Medium — most common" },
  { size: "2.8", diaIn: "2½″", diaMm: 63.5, circMm: 199.5, fit: "Large" },
  { size: "2.10", diaIn: "2⅝″", diaMm: 66.7, circMm: 209.4, fit: "Extra large" },
  { size: "2.12", diaIn: "2¾″", diaMm: 69.9, circMm: 219.4, fit: "Extra large +" },
];

export const RING_MEASURE_STEPS = [
  { title: "Use a ring you already love", text: "Place a well-fitting ring on a ruler and measure the inside diameter in millimetres, edge to edge. Match it to the diameter column." },
  { title: "Or wrap a strip of paper", text: "Cut a 1 cm-wide strip, wrap it snugly around the base of your finger, mark where it overlaps and measure the length in mm. This is your circumference." },
  { title: "Measure at the end of the day", text: "Fingers are largest in the evening and in warm weather. Measure then for the most comfortable everyday fit." },
  { title: "Mind the knuckle", text: "If your knuckle is noticeably wider than the base, choose a size between the two so the ring slides on yet stays put." },
];

export const BANGLE_MEASURE_STEPS = [
  { title: "Bring your fingers together", text: "Tuck your thumb into your palm and bring your fingertips together, as if slipping on a bangle." },
  { title: "Measure the widest point", text: "Wrap a soft tape (or a strip of paper) around the widest part of your hand, over the knuckles and thumb joint. Note the circumference in mm." },
  { title: "Match to the chart", text: "Choose the bangle whose inner circumference is equal to or just above your hand measurement. Between sizes? Size up for comfort." },
  { title: "Already own a bangle that fits?", text: "Measure its inner diameter in mm and compare with the diameter column — the simplest way to be sure." },
];

export function nearestRingSize(circMm) {
  if (!circMm) return null;
  return RING_SIZES.reduce((best, s) => (Math.abs(s.circ - circMm) < Math.abs(best.circ - circMm) ? s : best));
}

export function nearestBangleSize(handCircMm) {
  if (!handCircMm) return null;
  return BANGLE_SIZES.find((b) => b.circMm >= handCircMm) || BANGLE_SIZES[BANGLE_SIZES.length - 1];
}
